globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.DeleteFolder = (function(superClass) {

  utils.extend(DeleteFolder, superClass);

  function DeleteFolder() {
    return DeleteFolder.__super__.constructor.apply(this, arguments);
  }

  $.extend(DeleteFolder.prototype, {
    init: function() {
      var modal = this;

      modal._initEvents();

      return DeleteFolder.__super__.init.apply(this, arguments);
    },
    callbackSuccess: function(data){
      if(data && data.redirect_url) {
        window.location = data.redirect_url;
      } else {
        location.reload();
      }
    },
    _initEvents: function(){
      var modal = this;

      modal.$html.on('click', "input[type='radio']", function() {
        var $radio = $(this);

        if ($radio.hasClass('radio-transfer-images')) {
          modal.$html.find('.media-folder-select-container').show();
          modal.$html.find('.media-folder-select-container input').focus();
        };
        if ($radio.hasClass('radio-delete-images')) {
          modal.$html.find('.media-folder-select-container').hide();
        };
      });
    }
  });

  return DeleteFolder;

})(appCustomerSpace.Modal);
